import { AuthAccessReadScope, AuthAccessWriteScope } from "@t3tools/contracts";

import { usePrimarySessionState } from "~/environments/primary";

export function useAdministrativeAccess(): {
  hasAccess: boolean;
  canWrite: boolean;
  isPending: boolean;
} {
  const primarySessionState = usePrimarySessionState();
  const data = primarySessionState.data;
  if (!data) {
    return { hasAccess: false, canWrite: false, isPending: primarySessionState.isPending };
  }
  const scopes = data.authenticated ? (data.scopes ?? null) : null;
  return {
    hasAccess: scopes?.includes(AuthAccessReadScope) ?? false,
    canWrite: scopes?.includes(AuthAccessWriteScope) ?? false,
    isPending: false,
  };
}
